import { HttpIntegration } from "@/services/state/http-integration/httpIntegration-interface";
import {
  Box,
  FormControl,
  FormLabel,
  HStack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { DropDown } from "../Select/DropDown";
import { useSelector } from "react-redux";
import { AppDispatch, RootState } from "@/services/state/store";
import { useEffect } from "react";
import { Editor, useMonaco } from "@monaco-editor/react";
import { useDispatch } from "react-redux";
import { fetchDataTypes } from "../../services/state/custom-data-types/customDataTypes-async-calls";
import { DataType } from "@/services/state/custom-data-types/customDataTypes-interface";

export const ServiceProperties = ({
  httpIntegrations,
  selectedHttpIntegration,
  setSelectedHttpIntegration,
  selectedHttpIntegrationInputs,
  setSelectedHttpIntegrationInputs,
  defineGroovyLanguage,
  processModelMatchers,
  ruleMatchers,
  pvMatchers,
  dataTypes,
}: {
  httpIntegrations: HttpIntegration[];
  selectedHttpIntegration: HttpIntegration | undefined;
  setSelectedHttpIntegration: React.Dispatch<
    React.SetStateAction<HttpIntegration | undefined>
  >;
  selectedHttpIntegrationInputs: string[];
  setSelectedHttpIntegrationInputs: React.Dispatch<
    React.SetStateAction<string[]>
  >;
  selectedHttpIntegrationTargetVariableUuid: string;
  setSelectedHttpIntegrationTargetVariableUuid: React.Dispatch<
    React.SetStateAction<string>
  >;
  defineGroovyLanguage: (
    monacoInstance: any,
    ruleMatchers: string[],
    pvMatchers: string[],
    processModelMatchers: string[]
  ) => void;
  processModelMatchers: string[];
  ruleMatchers: string[];
  pvMatchers: string[];
  dataTypes: DataType[];
}) => {
  const monaco = useMonaco();

  useEffect(() => {
    if (monaco) {
      defineGroovyLanguage(
        monaco,
        ruleMatchers,
        pvMatchers,
        processModelMatchers
      );
    }
  }, [monaco]);

  // Editor options, including the custom theme and language
  const editorOptions = {
    selectOnLineNumbers: true,
    minimap: { enabled: false },
    readOnly: false,
  };

  return (
    <Box>
      <FormControl id="cs" mb={4}>
        <FormLabel color="white">Integration</FormLabel>
        <DropDown
          selected={{
            id: selectedHttpIntegration?.uuid as string,
            name: selectedHttpIntegration?.intgNm as string,
            component: <Text>{selectedHttpIntegration?.intgNm as string}</Text>,
          }}
          title={<Text></Text>}
          options={httpIntegrations.map((intg) => ({
            id: intg.uuid,
            name: intg.intgNm,
            component: <Text>{intg.intgNm}</Text>,
          }))}
          onOptionChange={(option) => {
            if (!Array.isArray(option)) {
              setSelectedHttpIntegration(
                httpIntegrations.find((intg) => intg.uuid === option.id)
              );
            }
          }}
        />
      </FormControl>

      <Text fontSize="18px" fontWeight="500" mt={3} color="white">
        Inputs:
      </Text>
      {selectedHttpIntegration?.intgIo?.map((io, index) => (
        <FormControl key={index} mt={3}>
          <HStack>
            <HStack width="30%" gap={3}>
              <FormLabel width="50%" color="white">{io.paramNm}</FormLabel>
              <FormLabel width="50%" color="white">
                {
                  dataTypes.find((type) => type.dataTypCd === io.dataTypeCd)
                    ?.dataTypNm
                }
              </FormLabel>
            </HStack>

            <Box width="70%" borderWidth="1px" borderRadius="md" overflow="hidden">
              <Editor
                value={selectedHttpIntegrationInputs?.at(index)}
                defaultLanguage="groovy"
                theme="vs-dark"
                height="10vh"
                width="100%"
                options={editorOptions}
                onChange={(e) => {
                  if (e) {
                    const copy = [...selectedHttpIntegrationInputs];
                    copy[index] = e;
                    setSelectedHttpIntegrationInputs(copy);
                  }
                }}
              />
            </Box>
          </HStack>
        </FormControl>
      ))}
    </Box>
  );
};
